import { useState, useEffect, useMemo, useCallback } from 'react';
import { DgtPdOrderPicklist } from '../models'
import { getDates } from '../utilities/Format'
import { PicklistStatus } from '../constants/EnumType'
import {
  getRequestedOrderPicklistsV2,
  getIssuedOrderPicklists,
  getHeaderPicklist
} from '../states/PicklistAction'

export default function useIssueOrder(
  status: string,
  orderType: string,
  dateFrom: Date,
  dateTo: Date,
  searchByOrder: string,
  division: string
) : DgtPdOrderPicklist[] {
  const [picklists, setPicklists] = useState<DgtPdOrderPicklist[]>([]);

  const fetchSinglePicklist = useCallback(async () => {
    const picklistHeader = await getHeaderPicklist(searchByOrder)
    if (picklistHeader) {
      setPicklists([ ...picklists, picklistHeader ])
    }
  }, [ searchByOrder, picklists ])

  useEffect(() => {
    const periodDates = getDates(dateFrom, dateTo) // sorted date FIFO (First In First Out)
    
    Promise.allSettled(periodDates.map(date => {
      if (status === PicklistStatus.PD_REQUESTED) {
        return getRequestedOrderPicklistsV2(date, division, orderType, PicklistStatus.PD_REQUESTED, true)
      }
      else if (status === PicklistStatus.WH_SHORTAGE) {
        return getRequestedOrderPicklistsV2(date, division, orderType, PicklistStatus.WH_SHORTAGE, true)
      }
      else if (status === PicklistStatus.WH_APPROVED) {
        return getIssuedOrderPicklists(date, division, orderType)
      }
      return Promise.reject(`Picklist Status not supported : ${status}`)
    })).then(results => {
      const totalPicklists = (results
        .filter(res => res.status === 'fulfilled') as PromiseFulfilledResult<DgtPdOrderPicklist[]>[])
        .reduce((prev, cur) => [...prev, ...cur.value], [] as DgtPdOrderPicklist[])
      setPicklists(totalPicklists)
    })
    .catch(err => console.error(err))
  }, [ status, orderType, dateFrom, dateTo, division ]);

  const filteredPicklists = useMemo(() => {
    return picklists.filter(pl => pl.pk.includes(searchByOrder))
  }, [ searchByOrder, picklists ])

  if (filteredPicklists.length === 0 && searchByOrder.length === 8) fetchSinglePicklist()

  return filteredPicklists
}